module.exports = __webpack_public_path__ + "img/221122-bimistock---------pk@1x.8a0a40ef.png";